import { sortObj } from '~cartzillagb/util'
import {
	withUniqueClass,
	withBlockStyles
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { RichText } from '@wordpress/block-editor'

import { applyFilters } from '@wordpress/hooks'

import { compose } from '@wordpress/compose'

import createStyles from './style'

const save = props => {

	const {
		blockName,
		styles,
		className,
		attributes,
	} = props

	const {
		hideMobile,
		hideTablet,
		hideDesktop,
		enableContainer,
		btnLink,
		btnText,
		btnIcon,
	} = attributes

	if( ! ( attributes.taxonomy && attributes.taxonomy.length > 0 ) ) {
		delete attributes.taxonomy
	}

	if( ! attributes.taxonomyType && ! ( attributes.taxonomy && attributes.taxonomy.length > 0 ) ) {
		delete attributes.taxonomyType
	}

	const data = {
		'data-attributes': JSON.stringify( sortObj( attributes ) ),
	}

	return (
		<div className={ classnames( [
			'wp-block-czgb-blog-post',
			className,
		], {} ) }>
			{ styles }
			<section className={ classnames( [
				'czgb-blog-post',
				'py-5',
			], {
				'czgb--hide-mobile' : hideMobile,
				'czgb--hide-tablet' : hideTablet,
				'czgb--hide-desktop' : hideDesktop,
			} ) }>
				<div className={ classnames( [
					'py-lg-3',
				], {
					'container' : enableContainer
				} ) }>
					{ applyFilters( `cartzillagb.${ blockName }.save.output.block-title`, null, null, props ) }
					<div className="cz-carousel" { ...data }></div>
					<div className="text-center pt-4 mt-md-2">
						<a className="btn btn-outline-accent" href={ btnLink }>
							<RichText.Content
								tagName="span"
								value={ btnText }
							/>
							<i className={ classnames( [
								btnIcon,
								'font-size-ms',
								'ml-1',
							], {} ) }></i>
						</a>
					</div>
				</div>
			</section>
		</div>
	)
}

export default compose(
	withUniqueClass,
	withBlockStyles( createStyles ),
)( save )
